import { render, staticRenderFns } from "./GenericTableBooleanCell.vue?vue&type=template&id=0172a252&scoped=true"
import script from "./GenericTableBooleanCell.vue?vue&type=script&lang=ts"
export * from "./GenericTableBooleanCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172a252",
  null
  
)

export default component.exports